export default __webpack_public_path__ + "static/media/svg-7.f429b162.svg";